import React from "react";
import variables from "@/common/globalVariables";

const bubble = (props) => {
  let backgroundColor = variables.accentColor1;

  if (props.color) {
    if (props.color === "2") {
      backgroundColor = variables.accentColor3;
    } else if (props.color === "3") {
      backgroundColor = variables.accentColor2;
    } else if (props.color === "4") {
      backgroundColor = variables.accentColor4;
    } else if (props.color === "5") {
      backgroundColor = variables.accentColor5;
    } else {
      backgroundColor = variables.accentColor1;
    }
  }

  const onDark = !!props.onDark;
  const keepColor = !!props.keepColor;
  const isAccentChip = props.color === "2" || props.color === "4";
  const useGlass = onDark && !isAccentChip && !keepColor;
  if (useGlass) {
    backgroundColor = "rgba(255, 255, 255, 0.14)";
  }

  const textColor =
    props.fontColor === "dark"
      ? variables.darkColor
      : variables.lightColor;

  return (
    <span
      style={{
        backgroundColor,
        border: useGlass ? "1px solid rgba(255, 255, 255, 0.28)" : "none",
        color: textColor,
      }}
    >
      {props.children}
      <style jsx>{`
        span {
          font-weight: 600;
          font-size: ${onDark ? "0.78rem" : "0.9em"};
          text-align: center;
          padding: ${onDark ? "5px 12px" : "4px 8px"};
          letter-spacing: ${onDark ? "0.01em" : "normal"};
          margin-left: ${onDark ? "0" : "5px"};
          margin-bottom: ${onDark ? "0" : "5px"};
          border-radius: 999px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
        }

        span:first-child {
          margin-left: 0px;
        }

        @media (min-width: 800px) {
          span {
            min-width: ${onDark ? "0" : "85px"};
          }
        }
      `}</style>
    </span>
  );
};

export default bubble;
